var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"writtenAi"},[_c('div',[_c('div',{staticClass:"head_hd"}),_c('div',{staticClass:"banner"},[_c('div',[_vm._v("一键续写")]),_c('div',{on:{"click":_vm.goshopp}},[_vm._v("领导讲话稿购买")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }